// 1.

// import React, { useState, useContext, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   CssBaseline,
//   Grid,
// } from "@mui/material";
// import { AuthenticationContext } from "../../../../context/AuthenticationContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const SupportForm = () => {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);
//   const LOGIN_ID = localStorage.getItem("LoginID");

//   const [formData, setFormData] = useState({
//     userid: "",
//     username: "",
//     capacity: "",
//     companyName: "",
//     location: "",
//     personname: "",
//     phone: "",
//     description: "",
//   });

//   /* ================= AUTO FILL ================= */
//   useEffect(() => {
//     if (LoggedInUserInfo) {
//       const cleanCompanyName = LoggedInUserInfo?.MSG
//         ? LoggedInUserInfo.MSG
//             .replace(/commissioned\s*by\s*:/i, "")
//             .replace(/plant\s*:?/i, "")
//             .replace(/\s+/g, " ")
//             .trim()
//         : "";

//       setFormData((prev) => ({
//         ...prev,
//         userid: LOGIN_ID || "",
//         username: LoggedInUserInfo?.username || "",
//         capacity: LoggedInUserInfo?.PLANT_CAPACITY || "",
//         companyName: cleanCompanyName,
//         location: `${LoggedInUserInfo?.Address || ""}, ${
//           LoggedInUserInfo?.city || ""
//         }`,
//       }));
//     }
//   }, [LoggedInUserInfo, LOGIN_ID]);

//   /* ================= INPUT HANDLER ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "phone") {
//       if (!/^\d*$/.test(value)) return;
//       if (value.length > 10) return;
//     }

//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.personname.trim()) {
//       alert("❌ Person Name is required");
//       return;
//     }

//     if (!formData.phone || formData.phone.length !== 10) {
//       alert("❌ Phone number must be exactly 10 digits");
//       return;
//     }

//     if (!formData.description.trim()) {
//       alert("❌ Description is required");
//       return;
//     }

//     try {
//       /* 🔥 EXACT POSTMAN-LIKE QUERY (NO + ISSUE) */
//       const queryParams =
//         `PLANT_NAME=${encodeURIComponent(formData.companyName)}` +
//         `&COMPANY_NAME=${encodeURIComponent(formData.companyName)}` +
//         `&PERSON_NAME=${encodeURIComponent(formData.personname)}` +
//         `&PHONE_NO=${encodeURIComponent(formData.phone)}` +
//         `&DESCRIPTION=${encodeURIComponent(formData.description)}`;

//       const bodyParams =
//         `USER_ID=${encodeURIComponent(LOGIN_ID)}` +
//         `&WEB_KEY=WEBXYZ`;

//       const apiUrl = `${BaseUrl}Invent_03_UP/iSupport?${queryParams}`;

//       /* 🔎 DEBUG (KEEP FOR NOW) */
//       console.log("🔵 QUERY STRING 👉", queryParams);
//       console.log("🟢 BODY STRING 👉", bodyParams);
//       console.log("🚀 FINAL API URL 👉", apiUrl);

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyParams,
//       });

//       const rawText = await response.text();
//       console.log("📦 RAW RESPONSE 👉", rawText);

//       const result = JSON.parse(rawText);

//       if (result.success && result.data) {
//         alert(`✅ Ticket Created Successfully\nTicket ID : ${result.data}`);
//       } else {
//         alert("⚠ Ticket created but Ticket ID not returned");
//       }

//       setFormData((prev) => ({
//         ...prev,
//         personname: "",
//         phone: "",
//         description: "",
//       }));
//     } catch (err) {
//       console.error("❌ API ERROR 👉", err);
//       alert("❌ Something went wrong");
//     }
//   };

//   /* ================= STYLES ================= */
//   const readonlyStyle = {
//     "& .MuiOutlinedInput-root": {
//       bgcolor: "#f0f9ff",
//       fontWeight: 500,
//       fontSize: "0.75rem",
//     },
//     "& .MuiInputBase-input.Mui-disabled": {
//       WebkitTextFillColor: "#0f172a",
//     },
//   };

//   const inputStyle = {
//     "& .MuiOutlinedInput-root": {
//       bgcolor: "rgba(236, 254, 255, 0.6)",
//     },
//   };

//   return (
//     <>
//       <CssBaseline />
//       <Box
//         sx={{
//           height: "100%",
//           display: "flex",
//           alignItems: "center",
//           borderRadius:".7rem",
//           justifyContent: "center",
//           p: 1,
//           background: `
//             radial-gradient(circle at top left, #bae6fd, transparent 40%),
//             radial-gradient(circle at bottom right, #99f6e4, transparent 40%),
//             linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%)
//           `,
//         }}
//       >
//         <Container maxWidth="sm">
//           <Paper elevation={10} sx={{ p: 3, borderRadius: 4 }}>
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 mb: 2,
//                 fontWeight: "bold",
//                 background:
//                   "linear-gradient(135deg, #0ea5e9 0%, #14b8a6 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               Support Form
//             </Typography>

//             <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="User ID"
//                     value={formData.userid}
//                     disabled
//                     fullWidth
//                     sx={readonlyStyle}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Plant Name"
//                     value={formData.username}
//                     disabled
//                     fullWidth
//                     sx={readonlyStyle}
//                   />
//                 </Grid>
//               </Grid>

//               <TextField label="Plant Capacity" value={formData.capacity} disabled sx={readonlyStyle} />
//               <TextField label="Company Name" value={formData.companyName} disabled sx={readonlyStyle} />
//               <TextField label="Location" value={formData.location} disabled sx={readonlyStyle} />

//               <TextField
//                 label="Person Name *"
//                 name="personname"
//                 value={formData.personname}
//                 onChange={handleChange}
//                 required
//                 sx={inputStyle}
//               />

//               <TextField
//                 label="Phone Number *"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 inputProps={{ maxLength: 10 }}
//                 helperText="Enter 10 digit mobile number"
//                 required
//                 sx={inputStyle}
//               />

//               <TextField
//                 label="Description *"
//                 name="description"
//                 multiline
//                 rows={2}
//                 value={formData.description}
//                 onChange={handleChange}
//                 required
//                 sx={inputStyle}
//               />

//               <Button
//                 type="submit"
//                 variant="contained"
//                 sx={{
//                   mt: 1,
//                   py: 1.2,
//                   borderRadius: 3,
//                   fontWeight: "bold",
//                   background:
//                     "linear-gradient(135deg, #0ea5e9 0%, #14b8a6 100%)",
//                 }}
//               >
//                 Save
//               </Button>
//             </Box>
//           </Paper>
//         </Container>
//       </Box>
//     </>
//   );
// };

// export default SupportForm;


import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Container,
  CssBaseline,
  Grid,
} from "@mui/material";
import { AuthenticationContext } from "../../../../context/AuthenticationContext";
import { BaseUrl } from "../../../../api/AxiosApi";

const SupportForm = () => {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const LOGIN_ID = localStorage.getItem("LoginID");

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    userid: "",
    username: "",
    capacity: "",
    companyName: "",
    location: "",
    personname: "",
    phone: "",
    description: "",
  });

  /* ================= AUTO FILL ================= */
  useEffect(() => {
    if (!LoggedInUserInfo) return;

    const cleanCompanyName = LoggedInUserInfo?.MSG
      ? LoggedInUserInfo.MSG
          .replace(/commissioned\s*by\s*:/i, "")
          .replace(/plant\s*:?/i, "")
          .replace(/\s+/g, " ")
          .trim()
      : "";

    setFormData((prev) => ({
      ...prev,
      userid: LOGIN_ID || "",
      username: LoggedInUserInfo?.username || "",
      capacity: LoggedInUserInfo?.PLANT_CAPACITY || "",
      companyName: cleanCompanyName,
      location: `${LoggedInUserInfo?.Address || ""}, ${
        LoggedInUserInfo?.city || ""
      }`,
    }));
  }, [LoggedInUserInfo, LOGIN_ID]);

  /* ================= INPUT HANDLER ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.personname.trim()) {
      alert("❌ Person Name is required");
      return;
    }

    if (formData.phone.length !== 10) {
      alert("❌ Phone number must be 10 digits");
      return;
    }

    if (!formData.description.trim()) {
      alert("❌ Description is required");
      return;
    }

    try {
      setLoading(true);

      /* ✅ QUERY PARAMS (EXACT POSTMAN FORMAT) */
      const queryParams =
        `PLANT_NAME=${encodeURIComponent(formData.companyName)}` +
        `&COMPANY_NAME=${encodeURIComponent(formData.companyName)}` +
        `&PERSON_NAME=${encodeURIComponent(formData.personname)}` +
        `&PHONE_NO=${encodeURIComponent(formData.phone)}` +
        `&DESCRIPTION=${encodeURIComponent(formData.description)}`;

      const bodyParams =
        `USER_ID=${encodeURIComponent(LOGIN_ID)}` +
        `&WEB_KEY=WEBXYZ` +
        `&LOGIN_TYPE=SOLAR` +
        `&LOGIN_ID2=${encodeURIComponent(LOGIN_ID)}`;

      const apiUrl = `${BaseUrl}Invent_03_UP/iSupport?${queryParams}`;

      console.log("🚀 FINAL API URL 👉", apiUrl);
      console.log("🟢 BODY 👉", bodyParams);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: bodyParams,
      });

      const rawText = await response.text();
      console.log("📦 RAW RESPONSE 👉", rawText);

      let result = {};
      try {
        result = JSON.parse(rawText);
      } catch {
        throw new Error("Invalid JSON response");
      }

      /* ✅ BACKEND SAFE CHECK */
      if (result?.data) {
        alert(`✅ Ticket Created Successfully\nTicket ID : ${result.data}`);
      } else {
        alert("⚠ Ticket created but Ticket ID not returned");
      }

      setFormData((prev) => ({
        ...prev,
        personname: "",
        phone: "",
        description: "",
      }));
    } catch (err) {
      console.error("❌ API ERROR 👉", err);
      alert("❌ Something went wrong while creating ticket");
    } finally {
      setLoading(false);
    }
  };

  /* ================= STYLES ================= */
  const readonlyStyle = {
    "& .MuiOutlinedInput-root": {
      bgcolor: "#f0f9ff",
      fontWeight: 500,
      fontSize: "0.8rem",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#0f172a",
    },
  };

  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      bgcolor: "rgba(236, 254, 255, 0.6)",
    },
  };

  return (
    <>
      <CssBaseline />
      {/* <Box
        sx={{
          minHeight: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        }}
      > */}
       <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          borderRadius:".7rem",
          justifyContent: "center",
          // p: 1,
          background: `
            radial-gradient(circle at top left, #bae6fd, transparent 40%),
            radial-gradient(circle at bottom right, #99f6e4, transparent 40%),
            linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%)
          `,
        }}
      >
        <Container maxWidth="sm">
          <Paper elevation={10} sx={{ p: 3, borderRadius: 4 }}>
            <Typography
              variant="h5"
              align="center"
              sx={{
                mb: 2,
                fontWeight: "bold",
                background:
                  "linear-gradient(135deg, #0ea5e9 0%, #14b8a6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Support 
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField label="User ID" value={formData.userid} disabled fullWidth sx={readonlyStyle} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Plant Name" value={formData.username} disabled fullWidth sx={readonlyStyle} />
                </Grid>
              </Grid>

              {/* <TextField label="Plant Capacity" value={formData.capacity} disabled sx={readonlyStyle} /> */}
              <TextField label="Company Name" value={formData.companyName} disabled sx={readonlyStyle} />
              <TextField label="Location" value={formData.location} disabled sx={readonlyStyle} />

              <TextField
                label="Person Name *"
                name="personname"
                value={formData.personname}
                onChange={handleChange}
                required
                sx={inputStyle}
              />

              <TextField
                label="Phone Number *"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                inputProps={{ maxLength: 10 }}
                helperText="Enter 10 digit mobile number"
                required
                sx={inputStyle}
              />

              <TextField
                label="Description *"
                name="description"
                multiline
                rows={2}
                value={formData.description}
                onChange={handleChange}
                required
                sx={inputStyle}
              />

              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{
                  mt: 1,
                  py: 1.2,
                  borderRadius: 3,
                  fontWeight: "bold",
                  background:
                    "linear-gradient(135deg, #0ea5e9 0%, #14b8a6 100%)",
                }}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default SupportForm;
